import React, { useEffect } from 'react';
import { SERVICE_DATA } from '../../../shared/population-colors';

interface AdvancedFiltersProps {
  serviceFilter: string[];
  daysFilter: string[];
  onServiceChange: (name: string) => void;
  onDaysChange: (day: string) => void;
  /** Se ejecuta automáticamente cuando cambian los filtros */
  onAutoApply?: () => void;
}

const AdvancedFilters: React.FC<AdvancedFiltersProps> = ({
  serviceFilter,
  daysFilter,
  onServiceChange,
  onDaysChange,
  onAutoApply,
}) => {
  const serviceData = Object.values(SERVICE_DATA);

  const dayOfWeek = [
    { dia: 'Lunes', inicial: 'L' },
    { dia: 'Martes', inicial: 'M' },
    { dia: 'Miércoles', inicial: 'M' },
    { dia: 'Jueves', inicial: 'J' },
    { dia: 'Viernes', inicial: 'V' },
    { dia: 'Sábado', inicial: 'S' },
    { dia: 'Domingo', inicial: 'D' },
  ];

  // ✔ aplicar automáticamente cada vez que cambian los arrays de filtros
  useEffect(() => {
    if (!onAutoApply) return;
    const t = setTimeout(() => onAutoApply(), 150); // pequeño debounce
    return () => clearTimeout(t);
  }, [serviceFilter, daysFilter, onAutoApply]);

  return (
    <div className="p-2 pt-0">
      {/* Servicios */}
      <div>
        <p className="text-primary text-sm md:text-lg font-semibold mb-4">
          ¿Qué servicio buscas?
        </p>
        <div className="flex flex-wrap gap-2">
          {serviceData.map((service) => {
            // Encontrar la clave del servicio para comparar con serviceFilter
            const serviceKey = Object.keys(SERVICE_DATA).find(key => SERVICE_DATA[key] === service);
            const isActive = serviceKey ? serviceFilter.includes(serviceKey) : false;
            
            return (
              <button
                key={service.name}
                onClick={() => onServiceChange(serviceKey || service.name)}
                className={[
                  'px-2 py-1 text-xs md:text-sm border border-primary rounded-lg hover:bg-gray-200',
                  isActive ? 'bg-primary bg-opacity-25' : '',
                ].join(' ')}
              >
                {service.label}
              </button>
            );
          })}
        </div>
      </div>

      {/* Días */}
      <div>
        <p className="text-primary text-sm md:text-lg font-semibold mb-4 mt-6">
          Días de atención
        </p>
        <div className="flex justify-center md:justify-start gap-2 mb-4">
          {dayOfWeek.map((d) => {
            const active = daysFilter.includes(d.dia);
            return (
              <button
                key={d.dia}
                onClick={() => onDaysChange(d.dia)}
                className={[
                  'rounded-full w-8 h-8 md:w-10 md:h-10 text-center ml-1 hover:bg-gray-200',
                  active ? 'bg-primary text-white' : 'border border-primary',
                ].join(' ')}
              >
                <p className="text-sm">{d.inicial}</p>
              </button>
            );
          })}
        </div>
      </div>

    </div>
  );
};

export default AdvancedFilters;
